import(/* webpackMode: "eager" */ "/home/runner/work/aldente/aldente/src/app/(marketing)/funcionalidades/page.tsx");
